import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import ImageViewModel from '@/ViewModels/Controls/ImageViewModel';
import Utilities from '@/Utility/Utilities';
import { IButtonViewModelConstructorParameter } from '#/DefaultViewExtensionInterfaces';

/**
 * Das ViewModel für Button
 */
export default class ButtonViewModel extends ControlViewModel {

    /**
     * Ein Handler, der aufgerufen wird, wenn der Button angeklick wird
     */
    public onClick: Function;

    /**
     * Das ViewModel für das Label
     */
    public label: LabelViewModel;

    /**
     * Das ViewModel für das Icon
     */
    public image: ImageViewModel;

    hasFocus: KnockoutObservable<boolean>;

    public textColor: KnockoutObservable<string>;
    
    public backgroundColor: KnockoutObservable<string>;
    
    public borderColor: KnockoutObservable<string>;

    public isPrimaryButton: KnockoutObservable<boolean>;

    public isFocusable: KnockoutObservable<boolean>;
    
    public hoverColor: KnockoutObservable<string>;

    /**
     * Das ViewModel für die Button
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: IButtonViewModelConstructorParameter) {
        super(params);
        this.onClick = this.handlerOrDefault(params.onClick);
        this.label = this.paramOrDefault(params.label, null);
        this.image = this.paramOrDefault(params.image, null);
        this.isPrimaryButton = this.observableOrDefault(params.isPrimaryButton, false);
        this.textColor = this.observableOrDefault(params.textColor, null);
        this.backgroundColor = this.observableOrDefault(params.backgroundColor, null);
        this.borderColor = this.observableOrDefault(params.borderColor, null);
        this.hoverColor = this.observableOrDefault(params.hoverColor, null);
        
        if (Utilities.isNullOrUndefined(params.isFocusable)) {
            this.isFocusable(true);
        }
    }
}

ComponentManager.setViewModel('ButtonViewModel', ButtonViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');